export default "__VITE_ASSET__Vk6zd2kQ__"